const actionTypes = {
    SET_USER_FAVORITE_BRANDS: 'SET_USER_FAVORITE_BRANDS'
};

module.exports = actionTypes;
